import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-volume-topography',
  templateUrl: './volume-topography.component.html',
  styleUrls: ['./volume-topography.component.scss']
})
export class VolumeTopographyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
